import { Component, Input, OnInit } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
} from '@ionic/angular';
import { CompetitionInfo } from 'src/data/competition-data';
import { Country } from 'src/data/country-location';
import { GameRoundInfo } from 'src/data/game-round';
import { ClubOutlet } from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { PlayerService } from 'src/providers/player-service/player-service';

@Component({
  selector: 'app-outlet-list',
  templateUrl: './outlet-list.page.html',
  styleUrls: ['./outlet-list.page.scss'],
})
export class OutletListPage implements OnInit {
  @Input() competition: CompetitionInfo;
  @Input() gameRound: GameRoundInfo;
  @Input() headerName: string;
  @Input() excludeAll: boolean = false;
  @Input() clubOutletList: Array<ClubOutlet>;
  @Input() fromClub: boolean = false;
  @Input() headerTitle: string = 'Select an outlet';
  @Input() clubId: number = null;
  @Input() listType: string = 'outlet';

  public countryList: Array<Country>;
  searchQuery: string;
  originalList: Array<Country>;
  selectedClubOutlet: ClubOutlet;

  constructor(
    public nav: NavController,
    private navParams: NavParams,
    // private viewCtrl: ViewController,
    private playerService: PlayerService,
    private loadingCtl: LoadingController,
    private modalCtrl: ModalController,
    private flightService: ClubFlightService
  ) {
    // this.excludeAll = this.navParams.get("excludeAll");
    // this.clubOutletList = this.navParams.get("clubOutletList");
    // this.fromClub = this.navParams.get("fromClub");
    // this.headerTitle = this.navParams.get("headerTitle");
    // if( this.navParams.get("clubId")) this.clubId = this.navParams.get("clubId");
    // this.listType = this.navParams.get("listType");
  }

  ngOnInit() {
    console.log(this.listType, this.newExpType, 'this.listType');
    if (this.listType === 'outlet') {
    }
    // this.getClubOutlet();
    else if (this.listType === 'outletType') {
      if (this.clubId) {
        this.getClubOutletType();
      } else {
        this.getOutletType();
      }
    }
  }

  clubOutletTypes: Array<any>= [];
  outletTypes: Array<any>= [];
  getClubOutletType() {
    let _clubId = this.clubId;
    this.flightService
      .getClubOutletType(_clubId)
      .subscribe((clubOutletType) => {
        console.log('club outlet Type : ', clubOutletType);
        if (clubOutletType) this.clubOutletTypes = clubOutletType;
      });
  }
  getOutletType() {
    this.flightService.getOutletType().subscribe((clubOutletType) => {
      console.log('outlet Types : ', clubOutletType);
      if (clubOutletType) this.clubOutletTypes = clubOutletType;

      console.log('outlet Types : ', this.clubOutletTypes);
    });
  }

  close() {
    this.modalCtrl.dismiss(null);
  }
  getInnerHTML() {
    let description =
      "<p><span style='background-color:#00FFFF'>Tournaments, electronic scorecards, analysis and more&hellip; Look no further! myGolf2u is a single place where you can find and register for any </span>competitions in your region, your favourite clubs or in the entire country on your phone or in this site.</p>";
    return description;
  }
  countrySelected(country?: any) {
    if (country === null) this.modalCtrl.dismiss(-999);
    else this.modalCtrl.dismiss(country);
  }
  async getCountry(cb?) {
    let loader = await this.loadingCtl.create({
      message: 'Getting Country List...',
      showBackdrop: false,
    });
    loader.present().then(() => {
      this.playerService.getCountryList().subscribe((data: Array<Country>) => {
        loader.dismiss().then(() => {
          // console.log("Country Sign Up : ",data)
          this.countryList = data;
          this.originalList = data;
          // console.log("Country List Sign Up : ", this.countryList)
        });
      }),
        (error) => {
          loader.dismiss();
        },
        () => {
          loader.dismiss();
        };
    });

    // setTimeout(()=>{
    //     console.log("Get country calling back");
    //     cb();

    // }, 0)
  }
  getFlagUrl(flagUrl: string) {
    if (flagUrl == null) return null;
    else {
      let flagIcon = flagUrl.split('/');
      return 'img/flag/' + flagIcon[2];
    }
  }
  onSearchInput(event) {
    this.countryList = this.originalList;

    if (this.searchQuery.length === 0) return false;
    let _country: Country;
    this.countryList = this.countryList.filter((country: Country) => {
      // return country.name.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
      if (
        country.name
          .toLowerCase()
          .trim()
          .includes(this.searchQuery.toLowerCase().trim())
      )
        return 1;
      else if (
        country.id
          .toLowerCase()
          .trim()
          .includes(this.searchQuery.toLowerCase().trim())
      )
        return 1;
      // else if(country.sportCode.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim()))
      //     return 1
      else return 0;
    });
  }

  outletSelectedType(type) {
    this.modalCtrl.dismiss(type);
  }
  onSearchCancel() {
    this.countryList = this.originalList;
  }
  expenditureSelected(expenditure) {
    this.modalCtrl.dismiss(expenditure);
  }
  outletSelected(outlet) {
    this.modalCtrl.dismiss(outlet);
  }
  newExpType: boolean = false;
  expenditureType: string = '';
  onAddExpenditureType() {
    this.newExpType = true;
    this.expenditureType = '';
  }
  onClearExpenditureType() {
    this.newExpType = false;
    this.expenditureType = '';
  }
}
